/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_S4_BodyInputs */

const en_fc_tut_s4_body = /** @type {(inputs: Fc_Tut_S4_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double-click a clip to load it into the Source monitor, mark an In and Out point, place the playhead on the timeline, then press , (comma) to insert or . (period) to overwrite. Repeat until your story is in order.`)
};

/**
* | output |
* | --- |
* | "Double-click a clip to load it into the Source monitor, mark an In and Out point, place the playhead on the timeline, then press , (comma) to insert or . (pe..." |
*
* @param {Fc_Tut_S4_BodyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_s4_body = /** @type {((inputs?: Fc_Tut_S4_BodyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_S4_BodyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_s4_body(inputs)
});
export { fc_tut_s4_body as "fc.tut.s4.body" }